import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["select"]
  static values = { url: String }

  connect() {
    this.tomSelect = new TomSelect(this.selectTarget, {
      create: false,
      maxItems: 1,
      maxOptions: 20,
      closeAfterSelect: true,
      placeholder: "Type at least 3 characters",
      loadThrottle: 250,
      shouldLoad: query => query.trim().length >= 3,
      onType: query => {
        if (query.trim().length < 3) {
          this.abortController?.abort()
          this.tomSelect.clearOptions()
          this.tomSelect.close()
        }
      },
      load: (query, callback) => this.loadGroups(query, callback),
      onChange: value => { if (value) this.element.requestSubmit() },
      render: {
        not_loading: () => '<div class="px-3 py-2 text-sm text-stone-500">Type at least 3 characters to find a group.</div>',
        no_results: () => '<div class="px-3 py-2 text-sm text-stone-500">No public groups match your search.</div>'
      }
    })
  }

  disconnect() {
    this.abortController?.abort()
    this.tomSelect?.destroy()
  }

  async loadGroups(query, callback) {
    this.abortController?.abort()
    this.abortController = new AbortController()
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query.trim())
    try {
      const response = await fetch(url, { headers: { Accept: "application/json" }, signal: this.abortController.signal })
      if (!response.ok) throw new Error("Group search failed")
      callback(await response.json())
    } catch {
      callback()
    }
  }
}
